import React from 'react';
const DiscoverySection = () => {
  return <div className="w-full bg-gray-200 text-gray-800 py-16 px-4" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700" data-id="element-80">
          Noc, której nie zapomnę
        </h2>
        <p className="text-lg mb-6" data-id="element-81">
          Tej nocy nie mogłam spać. Leżałam i myślałam – kiedy przestałam być
          sobą? Kiedy zgubiłam swoje marzenia, plany, pomysły na życie?
        </p>
        <p className="text-lg mb-6" data-id="element-82">
          Może wtedy, gdy tata umarł, a mama zaczęła potrzebować coraz więcej
          pomocy. Może gdy dzieci były małe i wszystko kręciło się wokół nich. A
          może po prostu któregoś dnia obudziłam się i zorientowałam, że moje
          życie należy do wszystkich – tylko nie do mnie.
        </p>
        <p className="text-lg mb-6" data-id="element-83">
          O 3 nad ranem wstałam i zaczęłam szukać w internecie. Nie wiedziałam
          nawet, czego szukam. Wpisywałam różne rzeczy: "jak odnaleźć siebie po
          50", "zagubiona w życiu", "nie mam swojego życia".
        </p>
        <p className="text-lg mb-6 font-bold" data-id="element-84">
          I wtedy trafiłam na przełomowe badania dr Joanny Radeckiej.
        </p>
        <div className="w-full h-px bg-gray-300 my-10" data-id="element-85"></div>
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700" data-id="element-86">
          Odkrycie, które przewróciło moje życie do góry nogami
        </h2>
        <div className="flex flex-col md:flex-row items-center mb-8" data-id="element-87">
          <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Dr Joanna Radecka" className="w-full md:w-1/3 h-64 object-cover rounded-lg mb-6 md:mb-0 md:mr-6" data-id="element-88" />
          <div data-id="element-89">
            <p className="text-lg mb-4" data-id="element-90">
              Dr Joanna Radecka, renomowana psychiatra i terapeutka, przez
              ostatnie 15 lat badała kobiety w mojej sytuacji – te z "pokolenia
              kanapkowego", dźwigające opiekę nad dziećmi i starzejącymi się
              rodzicami jednocześnie.
            </p>
            <p className="text-lg mb-4" data-id="element-91">
              Jej wnioski były szokujące i zmieniły moje rozumienie tego, co mi
              się dzieje:
            </p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-blue-400" data-id="element-92">
          <p className="text-lg italic" data-id="element-93">
            "Kobiety z pokolenia kanapkowego nie tracą siebie z dnia na dzień.
            To proces, który trwa latami. Najpierw rezygnują z małych rzeczy –
            kawy z przyjaciółką, wieczornego spaceru. Potem z większych – hobby,
            pasji, marzeń. W końcu zapominają, kim były, zanim stały się
            wszystkim dla wszystkich."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-94">
          Czytałam to o 3:30 nad ranem i płakałam. Bo to byłam ja. Co do słowa.
        </p>
        <p className="text-lg mb-6 font-bold" data-id="element-95">
          Ale to, co napisała dalej, kompletnie rozwaliło moje dotychczasowe
          myślenie:
        </p>
      </div>
    </div>;
};
export default DiscoverySection;